 <template>
  <div class="container">
    <!-- 主体内容 -->
    <div class="main-content">
      <div class="header">
        <p class="keyCode" style="font-size: 16px;">桌位号 ： {{ deskCode.code }}</p>
        <div v-if="payMethodType == 2" class="keyCode">
          <p style="width: 70px;font-size: 16px;">手牌号 ：</p>
          <p >{{ deskCode.cardCode }}</p>
        </div>
      </div>
      <div class="content">
        <!-- 右侧菜品列表 -->
        <div class="menu-list">
          <div class="cart_goods_con" style="background-color: white">
            <div style="display: flex; flex-direction: column">
              <div
                v-for="(group, index) in allCarGoodsArr"
                :key="index"
                style="margin-left: 10px; margin-right: 10px"
              >
                <div class="TitleName">
                  <div style="flex: 1;height: 1px;"/>
                  <div style="height: 1px;width: 100px; background-color: #E1E8DF;margin-right: 10px;"/>
                  <p style="font-weight: 400;">{{ group.TitleName }}</p>
                    <div style="height: 1px;width: 100px; background-color: #E1E8DF;margin-left: 10px;"/>
                    <div style="flex: 1;height: 1px;"/>
                </div>
                <p class="GoodsCatalogName" style="color: #737A84;font-size: 16px;">{{ group.GoodsCatalogName }}</p>
                <div
                  v-for="(item, j) in group.children"
                  :key="j"
                  style="margin-top: 5px; height: 80px"
                >
                  <div style="display: flex">
                    <img
                      v-if="item.PicUrl && item.PicUrl.length > 0"
                      :src="item.PicUrl"
                      style="width: 104px; height: 51px; border-radius: 10px"/>
                    <img
                      v-else
                      :src="require('@/assets/order/1@2x(20).png')"
                      style="width: 104px; height: 51px; border-radius: 10px"
                    />
                    <div style="flex: 1">
                      <div class="goodsname-item" style="font-size: 14px;font-weight: 700;">{{ item.GoodsName }}</div>
                      <div
                        class="goodsname-item"
                        style="display: flex; height: 40px"
                      >
                        <div style="width: auto;color: #737A84;font-size: 14px;font-weight: 700;">{{ item.Price }}</div>
                        <div class="goods-Unit" style="font-size: 12px">
                          元 / {{ item.Unit ? item.Unit : "份" }}
                        </div>
                        <div style="flex: 1"></div>
                        <div class="goods-num" >x {{ item.num }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部订单栏 -->
    <div class="order-bar">
      <div style="flex: 1">
        <div
          style="
            color: #737a84;
            font-size: 18px;
            display: flex;
            margin-top: 10px;
            color: #737A84;
            font-weight: 700;
            height: 20px;"
        >
          <p style="width: auto;color: #97A0A9;font-size: 14px;font-weight: normal;">合计:</p>
          {{ allMoney.toFixed(2) }}
          <p style="font-size: 14px;  margin-left: 5px;font-weight: normal;">
            元
          </p>
        </div>
        <p style="color: #B7BDC3; font-size: 12px;color: #B7BDC3;">共计{{ allCount }}道菜</p>
      </div>

      <div
        class="confirm-btn"
        :loading="isSubmitLoading"
        style="margin-left: 10px;width: 180px;"
        @click="submitOrder"
      >
        继续加菜
      </div>
      <div
        v-if="payMethodType==1&&orderId!=null"
        style="margin-left: 10px;width: 180px;"
        class="confirm-btn"
        :loading="isSubmitLoading"
        @click="submitOrderPay"
      >
        立即支付
      </div>
    </div>
  </div>
</template>

<script>
import { handleSessionStorage } from "@/utils";
import { numberToChinese } from "@/utils/numberToChinese";
export default {
  name: "MicropointHistoryConsume",
  data() {
    return {
      searchInputVaule: "",
      deskCode: {},
      teamId: "",
      diningRoomId: "",
      saasCode: "",
      isSureVpn: false,
      allMoney: 0.0,
      allCount: 0,
      VpnInfo: {},
      allCarGoodsArr: [],
      orgGoodsArr: [],
      payMethodType: 2,
      orderId: null,
      SequenceId: null,
      preOrderId: undefined,
      EnableTeamOrder: false,
      isSubmitLoading: false
    };
  },
  created() {
    this.deskCode = handleSessionStorage.get("deskCode");
    this.teamId = handleSessionStorage.get("teamId");
    this.saasCode = this.$route.query.saasCode;
    this.isSureVpn = handleSessionStorage.get("isSureVpn");
    const vpnStorage = handleSessionStorage.get("vpnInfo");
    this.VpnInfo = vpnStorage;
    this.diningRoomId = handleSessionStorage.get("diningRoomId");
    const deskObj = handleSessionStorage.get("deskCode");
    this.orderPeople = deskObj.PersonNum ? deskObj.PersonNum : 1;
    this.payMethodType = deskObj.PayMode ? deskObj.PayMode : 1;
    this.EnableTeamOrder = handleSessionStorage.get("EnableTeamOrder");
    this.handleGetHistoryOrder();
  },

  methods: {
    submitOrder() {
      handleSessionStorage.remove("menuIndex");
      this.$router.back();
    },

    submitOrderPay() {
      this.orderId = null
      this.orgGoodsArr.forEach(item=>{
        if (item.Status == 0) {
         this.orderId = item.Id
       }
      })
      if(this.orderId==null){
        this.$toast("当前消费均支付，请不要重复结账");
        return
      }
      this.$router.replace({
        name: "PayList",
        query: {
          id: this.orderId,
          SequenceId: this.SequenceId,
          fromPage: "food",
        },
      });
    },

    handleGetHistoryOrder() {
      const param = {
        vpnId: this.VpnInfo.id,
        keyCode: this.deskCode.cardCode,
        tableCode: this.deskCode.code,
      };
      $http("wechath5/zh-cn/v1/meal/orderlist", param, "get").then((res) => {
        const tempGoodsArr = []
        this.orgGoodsArr = []
        this.orgGoodsArr = res
        this.orderId=null
        this.allMoney = 0.0;
        this.allCount = 0.0;
        res.forEach((item) => {
             if (item.Status == 0) {
               this.orderId = item.Id;
             }
          this.SequenceId = item.SequenceId;
          this.allMoney += item.OrigMoney;
          if (item.Details.length > 0) {
            item.Details.forEach((dItems) => {
              this.allCount += dItems.Quantity;
              const consume = {
                ProductId: dItems.ProductId,
                GoodsName: dItems.ProductName,
                PicUrl: dItems.ProductImage,
                num: dItems.Quantity,
                Price: dItems.Price,
                Remark: dItems.Remark || "",
                GoodsCatalog: dItems.ProductType,
                CreateTime: dItems.CreateTime,
                KeyCode: dItems.KeyCode || "",
                OrderId: dItems.OrderId,
                WxUserId: dItems.WxUserId || null,
                Price: dItems.Price,
                Unit: dItems.Unit || "份",
                Id: dItems.Id,
                UseStartDate: dItems.UseStartDate || "",
                UseEndDate: dItems.UseEndDate || "",
                GoodsServiceId: dItems.GoodsServiceId || "0",
                TypeId: dItems.TypeId,
                Status: dItems.Status || 0,
                Name: dItems.Specification, //规格名称
              };
              tempGoodsArr.push(consume);
            });
          }
        });
        this.queryShopingCarData(tempGoodsArr)
      });
    },

    queryShopingCarData(tempGoodsArr) {
      this.allCarGoodsArr = [];
      const hashTimeMap = {};
      const typeArray = [];
      tempGoodsArr.forEach((mode) => {
        this.$set(hashTimeMap, mode.CreateTime, mode.CreateTime);
        if (!typeArray.includes(mode.GoodsCatalog)) {
          typeArray.push(mode.GoodsCatalog);
        }
      });
      const list = Object.values(hashTimeMap);
      const sortedArray = list.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      sortedArray.forEach((time, index) => {
        const consumeList = tempGoodsArr.filter(
          (mode) => time == mode.CreateTime
        );
        typeArray.forEach((GoodsCatalog) => {
          const children = consumeList.filter(
            (mode) => GoodsCatalog == mode.GoodsCatalog
          );
          if (children.length > 0) {
            this.allCarGoodsArr.push({
              TitleName: "第" + numberToChinese(index + 1) + "次",
              GoodsCatalogName: GoodsCatalog,
              children: children,
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.header {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  width: 100%;
  height: 60px;
  color: #737A84;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #f1f1f1;

  .keyCode {
    margin-left: 15px;
    color: #737A84;
    flex: 1;
    display: flex;
  }
}
.main-content {
  width: 100%;
  flex: 1;
}
.content {
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  width: 100%;
  /* height: 100%; */
}
.menu-list {
  width: 100%;
  overflow-y: auto;
  height: calc(100vh - 250px);
}
.menu-item {
  display: flex;
  height: auto;
  border: 1px solid #eeeded;
  border-radius: 4px;
  margin-bottom: 20px;
}
.goodsname-item {
  text-align: left;
  color: #737A84;
  height: 60px;
  margin-left: 20px;
  margin-right: 20px;
  font-weight: 700;
  width: 100%;
  text-align: left;
  line-height: 60px;
}
.goods-PicUrl {
  height: 280px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.goods-Unit {
  width: auto;
  color: #97a0a9;
  margin-left: 6px;
  font-size: 20px;
}
.goods-num {
  min-width: 80px;
  height: 40px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  font-size: 30px;
}
.order-bar {
  @include fixed-bottom-box-con;
  height: 100px;
  align-items: center;
  line-height: 100px;
  border: 1px solid lightgray;
  display: flex;
  margin-bottom: 0px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0px 2px 6px 0px rgba(164, 193, 158, 0.4);
  backdrop-filter: blur(2px);
}

.confirm-btn {
  background-color: RGBA(234, 242, 232, 1);
  height: 80px;
  color: #849d80;
  line-height: 80px;
  border-radius: 40px;
  font-weight: 600;
  font-size: 36px;
  width: 220px;
  text-align: center;
}

.red-good-num {
  width: auto;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: red;
  border-radius: 40px;
  color: white;
  text-align: center;
  font-size: 25px;
}

.overlay_con_content {
  width: 100%;
  margin-left: 10px;
  margin-right: 10px;
  background-color: white;
  border-radius: 10px;
  align-items: center;
  color: #737a84;
  font-size: 37px;
}
.overlay_con_p {
  text-align: center;
  margin-top: 40px;
  height: 48px;
  line-height: 48px;
  color: #737a84;
  font-size: 34px;
}
.custom-button {
  color: #849d80 !important;
  font-weight: bold;
}
.cancel-custom-button {
  color: #97a0a9 !important;
  font-weight: bold;
  background: white !important;
  border: 1px solid #eaeaea;
}
.remark-class {
  margin-top: 30px;
  background-color: white;
  border-radius: 30px;
  height: 160px;
  width: 100%;
  color: #737a84;
}
.input-class {
  height: 50px;
  width: 100%;
  font-size: 10sp;
  border: 0px solid transparent;
}
.TitleName {
  color: #737a84;
  text-align: center;
  padding-top: 20px;
  align-items: center;
  display: flex;
  font-size: 1rem;
  padding-bottom: 10px;
}
.GoodsCatalogName {
  color: #737a84;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>